import React from 'react';
import PropTypes from 'prop-types';
import { getIconPriceFollowReferencePrice } from './../../helpers/Color';
import { formatChange, formatTextFloat } from './../../helpers/Text';

function renderContent(
  price,
  referencePrice,
  change,
  percentChange,
  classNameColor,
) {
  return (
    <div className="item-first">
      <strong className={classNameColor}>
        {formatTextFloat(price.toString().split('.')[0], 0)}
      </strong>
      <span style={{ paddingRight: '3px' }}>
        <small className={classNameColor}>
          .{price.toString().split('.')[1]}
        </small>
        <small>VND</small>
      </span>
      <span>
        <small className={classNameColor}>{formatChange(change)}</small>
        <small className="d-flex">
          <i
            className={`${classNameColor} ${getIconPriceFollowReferencePrice(
              price,
              referencePrice,
            )} fs-10 mr-1`}
          />
          <span>
            &nbsp;
            {percentChange}
            {percentChange !== '--' && ' %'}
          </span>
        </small>
      </span>
    </div>
  );
}
class PriceInfo extends React.Component {
  render() {
    const {
      price,
      referencePrice,
      change,
      percentChange,
      classNameColor,
    } = this.props;

    const returnContent =
      parseFloat(price) > 0
        ? renderContent(
            price,
            referencePrice,
            change,
            percentChange,
            classNameColor,
          )
        : renderContent('--', '--', '--', '--', classNameColor);

    return returnContent;
  }
}

PriceInfo.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  referencePrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  change: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  percentChange: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  classNameColor: PropTypes.string.isRequired,
};

export default PriceInfo;
